import { SearchSelect } from '@dru/ui';
import { ALL_PLANTS, type PlantAccessMode } from '../lib/plant-access';

/** The plant a new user works for; nothing is shown for a role that covers the whole company. */
export function PlantAccessField({ mode, plants, value, onChange }: {
  mode: PlantAccessMode;
  plants: Array<{ id: string; code: string; name: string }>;
  value: string;
  onChange: (next: string) => void;
}) {
  if (mode === 'none') return null;
  return (
    <SearchSelect
      label="Plant"
      required
      value={value}
      onChange={onChange}
      info="They see only this plant's employees, examinations and reports."
      error={mode === 'required' && plants.length === 0 ? 'Add a plant first.' : undefined}
      placeholder="Choose a plant…"
      searchPlaceholder="Search plants by name or code…"
      options={[
        ...(mode === 'optional' ? [{ value: ALL_PLANTS, label: 'All plants — the whole company' }] : []),
        ...plants.map((p) => ({ value: p.id, label: p.name, hint: p.code })),
      ]}
    />
  );
}
